import { render, staticRenderFns } from "./EditOwnerModal.vue?vue&type=template&id=40dd9768&scoped=true"
import script from "./EditOwnerModal.vue?vue&type=script&lang=js"
export * from "./EditOwnerModal.vue?vue&type=script&lang=js"
import style0 from "./EditOwnerModal.vue?vue&type=style&index=0&id=40dd9768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd9768",
  null
  
)

export default component.exports